import { FormInstance } from 'antd';
import { useState } from 'react';

import { toSendCustomerEmail } from '../utils';

import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { setLocalData } from '~/core/helpers/storageHelper';
import useEstimateSaver from '~/core/hooks/useEstimateSaver';
import { CustomerDataModel, CustomerInfo } from '~/core/models';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectSaveAction,
  updateSelectedCustomerData,
} from '~/redux/slices/customerData';

const useCustomerFormEvents = (
  form: FormInstance<CustomerDataModel>,
  handleClose: () => void
) => {
  const [isSendingEstimateInfo, setIsSendingEstimateInfo] =
    useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { saveEstimate } = useEstimateSaver();
  const saveAction = useAppSelector(selectSaveAction);

  const saveEstimateWithCustomerData = async (customerInfo: CustomerInfo) => {
    try {
      setIsSendingEstimateInfo(true);
      setLocalData(LOCAL_STORAGE_KEY.KEEP_LOAD_ESTIMATE_IN_URL, true);
      await saveEstimate(customerInfo, saveAction);
    } catch (_e) {
      // TODO: Do we need to handle errors here? How?
    } finally {
      setIsSendingEstimateInfo(false);
      handleClose();
    }
  };

  const updateCustomerDataAndEstimate = async (values: CustomerDataModel) => {
    const customerInfo = {
      customerName: values.customerName?.trim(),
      email: values.email?.trim(),
      phone: values.phone?.trim(),
      alternatePhone: values.alternatePhone?.trim(),
      address1: values.address1?.trim(),
      address2: values.address2?.trim(),
      city: values.city?.trim(),
      state: values.state?.toUpperCase(),
      zip: values.zip?.trim(),
      sendCustomerEmail: toSendCustomerEmail(values.doNotEmailEstimate),
    };

    const customerData: CustomerDataModel = { ...values, ...customerInfo };

    dispatch(updateSelectedCustomerData(customerData));

    saveEstimateWithCustomerData(customerInfo);
  };

  const callFormSubmit = () => form.submit();

  const resetFieldsAndClose = () => {
    const { city, state, zip } = form.getFieldsValue(['city', 'state', 'zip']);

    form.resetFields();

    form.setFieldsValue({
      city,
      state,
      zip,
    });

    handleClose();
  };

  return {
    callFormSubmit,
    isSendingEstimateInfo,
    resetFieldsAndClose,
    updateCustomerDataAndEstimate,
  };
};

export default useCustomerFormEvents;
